export class CardModel {
  id: string = "0";
  cardTitle: string = "";
  cardBody: string = "";
  isFavourite: boolean = false;
  surveyResults: string = "";
  status: string = "";
  accessLevel: string = "";
  createdDate:Date;
  IsGroupOwner:boolean=false;
  IsWorkflow:boolean=false;
  isWfPublished:boolean=false;
  IsWFShared:boolean=false;
  surveyGroupName: string= "";
  surveyGroupId: string="0";
  isArchived : boolean = false;
  isREResponse : boolean= false;
  dueDaysCount:number=0;
  isLoginRequired: boolean = true;
  isCPResponse : boolean= false;
  IsSharedWithOwn:boolean=false;
  isAssigned:boolean=false;
  resultsCount:number=0;
  inprogressCount:number=0;
  isMultipleResponseAllowed:boolean=true;
  dueDate:Date;
  isOverdueAccessAllowed:boolean=false;
  isOverdue:boolean=false;
}
